import { DualPalette } from "../types";

export const neutral: DualPalette = {
  50:  { light: "#f8fafc", dark: "#f8fafc" },
  100: { light: "#f1f5f9", dark: "#f1f5f9" },
  200: { light: "#e2e8f0", dark: "#e2e8f0" },
  300: { light: "#cbd5e1", dark: "#cbd5e1" },
  400: { light: "#94a3b8", dark: "#94a3b8" },
  500: { light: "#64748b", dark: "#64748b" },
  600: { light: "#475569", dark: "#475569" },
  700: { light: "#334155", dark: "#334155" },
  800: { light: "#1e293b", dark: "#1e293b" },
  900: { light: "#0f172a", dark: "#0f172a" },
};
